exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".example-content{height:calc(100vh - 70px);padding-top:10px;padding-left:10px}.example-content section{height:100%}.example-content section h2{padding:10px}.example-content section .block-demo{margin-top:0;height:calc(100vh - 150px)}\n", ""]);

